export default __webpack_public_path__ + "static/media/etc07.0941d1ef.png";